import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function ArtistsPreview() {
  const [artists, setArtists] = useState([]);
  useEffect(() => {
    api.get("/artists").then((r) => setArtists(r.data.slice(0, 12))).catch(() => {});
  }, []);
  return (
    <section className="relative py-32 md:py-40 px-6 md:px-12 bg-fg text-bg" data-testid="artists-preview">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <div className="meta-label text-cinabre">§ Les artistes</div>
            <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight mt-6">
              194 <em className="italic">voix</em>, une ligne.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 self-end">
            <p className="text-bg/75 leading-relaxed text-lg max-w-xl">
              Objectif <span className="text-cinabre">194 artistes · 194 pays UNESCO</span> à l'horizon 2030. Peintres, photographes, sculpteurs, poètes et performers convergent depuis 2024 (JAIMECASTEL) et 2025 (Canal'Art · Octobre Rose). En 2026, ils investissent les six sites emblématiques du Canal du Midi.
            </p>
            <Link to="/artistes" className="btn-editorial mt-8 bg-bg text-fg border-bg hover:bg-cinabre hover:text-bg hover:border-cinabre" data-testid="see-all-artists">
              Voir tous les artistes
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {artists.map((a, i) => (
            <motion.div
              key={a.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.8, delay: (i % 4) * 0.06 }}
            >
              <Link
                to={`/artistes/${a.slug}`}
                className="group relative overflow-hidden aspect-[3/4] border border-bg/15 block"
                data-testid={`artist-tile-${i}`}
              >
                <img src={a.image} alt={a.name} className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-fg via-fg/40 to-transparent opacity-70 group-hover:opacity-85 transition" />
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-cinabre">{a.medium}</div>
                  <div className="font-serif text-xl md:text-2xl leading-tight mt-1">{a.name}</div>
                  <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-bg/70 mt-1">→ {a.site}</div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
